import { useToast } from '@chakra-ui/toast';
import React, { useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';

function Notifications() {
  const toast = useToast();
  const notification = useSelector(state => state.notifications.notification);

  const addNotification = useCallback((text, status) => {
    toast({
      description: text,
      status: status,
      duration: 5000,
      isClosable: true
    });
  }, [toast]);

  useEffect(() => {
    if (Object.keys(notification).length === 0) {
      return;
    }
    const { msg, status } = notification;
    addNotification(msg, status);
  }, [notification, addNotification]);

  return <div/>;
}

export default Notifications;
